import { Instance } from 'mobx-state-tree';
import { DriverActionDtoModelBase } from './DriverActionDtoModel.base';

/* The TypeScript type of an instance of DriverActionDtoModel */
export interface DriverActionDtoModelType extends Instance<typeof DriverActionDtoModel.Type> {}

/* A graphql query fragment builders for DriverActionDtoModel */
export { selectFromDriverActionDto, driverActionDtoModelPrimitives, DriverActionDtoModelSelector } from './DriverActionDtoModel.base';

/**
 * DriverActionDtoModel
 */
export const DriverActionDtoModel = DriverActionDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
